module.exports = __webpack_public_path__ + "static/media/trainers.e3e388c8.jpg";